/*
 * Note - this module is not meant to be imported directly. Instead, use the global
 * alias 'plugin_data', which is provided by apiSpecExportTools.js
 */
export default (global['kolibriPluginDataGlobal'] || {})[__kolibriModuleName] || {};
